import object1 from "./1.png";

export const antioxidantMakeupRemover1 = [
  object1,
  object1,
  object1,
  object1,
  object1,
];
